import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { logException } from './util/logger';


class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI and log to Raven
    this.setState({ hasError: true }, () => {
      logException(error, info);
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <h3 style={{ padding: '20px' }}>
          There was an unexpected error.
          Our engineers have been notified and will work towards a solution.
        </h3>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ErrorBoundary;



/** WEBPACK FOOTER **
 ** ./src/ErrorBoundary.jsx
 **/